import type { AxiosError } from 'axios';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import type { Organization } from '@/types/organization';
import type PaginatedResponse from '@/types/paginatedResponse';
import type RepositoryResponse from '@/types/repositoryResponse';
import ajax from '@/utils/ajax';
import defaultRepositoryError from '@/utils/defaultRepositoryError';
import logAjaxError from '@/utils/logAjaxError';

import type { OrganizationsParams } from './types';

export const organizationRepository = {
  async getOrganizations({
    host,
    params
  }: {
    host: string;
    params: OrganizationsParams;
  }): Promise<RepositoryResponse<PaginatedResponse<Organization[]>>> {
    try {
      const path = `/api/organizations/`;
      const response = await ajax.get({ url: `${host}${path}`, params: { ...params } });

      return {
        data: response.data,
        isError: false
      };
    } catch (error) {
      logAjaxError(error);
      return defaultRepositoryError(error as AxiosError, 'Failed to get organizations.');
    }
  }
};

const OrganizationRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async getOrganizations(
      params: OrganizationsParams
    ): Promise<RepositoryResponse<PaginatedResponse<Organization[]>>> {
      return organizationRepository.getOrganizations({ host, params });
    }
  };
};

export default OrganizationRepository;
